import React, { useState, useEffect } from "react";
import styles from "./ScrollToTop.module.css";
import { SlArrowUpCircle } from "react-icons/sl";
import { IconBaseProps } from "react-icons";

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  const ArrowUpCircle = SlArrowUpCircle as React.ComponentType<IconBaseProps>;

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div
      className={`${styles.scrollToTop} ${isVisible ? styles.visible : ""}`}
      onClick={scrollToTop}
    >
      <ArrowUpCircle size={32} />
    </div>
  );
};

export default ScrollToTop;
